import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getLibrarySongs,
  addSongToLibrary,
  addBulkSongsToLibrary,
  deleteSongFromLibrary
} from "../../helpers/songLibrarySong_helper";

export const fetchLibrarySongs = createAsyncThunk(
  'songLibrarySong/fetchAll',
  async ({ libraryId, page = 1, itemsPerPage = 10, search = '' }, { rejectWithValue }) => {
    try {
      const response = await getLibrarySongs(libraryId, page, itemsPerPage, search);

      // Handle both Hydra format and plain array
      const items = response['hydra:member'] || (Array.isArray(response) ? response : []);
      const totalItems = response['hydra:totalItems'] || (Array.isArray(response) ? response.length : 0);

      console.log('fetchLibrarySongs response:', { response, items, totalItems });

      return {
        items,
        totalItems,
        page,
        itemsPerPage
      };
    } catch (error) {
      console.error('fetchLibrarySongs error:', error);
      return rejectWithValue(error || 'Failed to fetch library songs');
    }
  }
);

const extractErrorMessage = (error) => {
  if (typeof error === 'string') return error;
  if (Array.isArray(error)) {
    return error.map(e => e.message || e).join(', ');
  }
  if (error?.message) return error.message;
  if (error?.violations && Array.isArray(error.violations)) {
    return error.violations.map(v => v.message).join(', ');
  }
  return 'An error occurred';
};

export const addLibrarySong = createAsyncThunk(
  'songLibrarySong/add',
  async (data, { rejectWithValue }) => {
    try {
      return await addSongToLibrary(data);
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const addBulkLibrarySongs = createAsyncThunk(
  'songLibrarySong/addBulk',
  async (data, { rejectWithValue }) => {
    try {
      return await addBulkSongsToLibrary(data);
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const removeLibrarySong = createAsyncThunk(
  'songLibrarySong/delete',
  async (id, { rejectWithValue }) => {
    try {
      await deleteSongFromLibrary(id);
      return id;
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error));
    }
  }
);
